export function getDataFromLocalStorage(key: string) {
  const localStorageValue = localStorage.getItem(key)
  return localStorageValue ? JSON.parse(localStorageValue) : undefined
}
